var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.855,
    height: 38.777,
    viewBox: "0 0 46.855 38.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.266,38.777V35.929H6.857V17.7h2.87V35.929h28.7V17.7h2.87V35.929h4.017v2.848Zm23.53-7.4V28.525H29.24v2.848Zm-6.886,0V28.525h3.443v2.848ZM25.8,23.4V20.551H29.24V23.4Zm-6.886,0V20.551h3.443V23.4ZM0,14.566,7.069,10.3H6.857V1.454A1.472,1.472,0,0,1,8.358.047h6.173A1.48,1.48,0,0,1,16.04,1.454v3.26L23.3.242C24.327-.391,22.954-.905,46.855,14.2L45.314,16.6,24,3.151,1.507,16.956ZM9.727,8.5,13.17,6.472V2.895H9.727Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewHouse);
export default __webpack_public_path__ + "static/media/new_house.af53dc02.svg";
export { ForwardRef as ReactComponent };